module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_twitter-6036071cff14b7022a21429c0fd0da2e.svg";